import React from 'react';

import cumulObject from '../doc/docParser'


import PieChartDEMO from '../samples/PieChartHomeReact';
import { textCode as PieChartDEMOReact } from '../samples/PieChartHomeReact';
import { textCode as PieChartDEMOJQ } from '../samples/PieChartHomeJQ';
import { src as PieChartsrc } from '../samples/PieChartHomeReact';

import DoublePieChartDEMO from '../samples/DoublePieChartHomeReact';
import { textCode as DoublePieChartDEMOReact } from '../samples/DoublePieChartHomeReact';
import { textCode as DoublePieChartDEMOJQ } from '../samples/DoublePieChartHomeJQ';
import { src as DoublePieChartsrc } from '../samples/DoublePieChartHomeReact';

import TimelineDEMO from '../samples/TimelineHomeReact';
import { textCode as TimelineDEMOReact } from '../samples/TimelineHomeReact';
import { textCode as TimelineDEMOJQ } from '../samples/TimelineHomeJQ';
import { src as Timelinesrc } from '../samples/TimelineHomeReact';

import TimelineTDEMO from '../samples/TimelineTHomeReact';
import { textCode as TimelineTDEMOReact } from '../samples/TimelineTHomeReact';
import { textCode as TimelineTDEMOJQ } from '../samples/TimelineTHomeJQ';
import { src as TimelineTsrc } from '../samples/TimelineTHomeReact';

import BarDEMO from '../samples/BarHomeReact';
import { textCode as BarDEMOReact }  from '../samples/BarHomeReact';
import { textCode as BarDEMOJQ } from '../samples/BarHomeJQ';
import { src as Barsrc } from '../samples/BarHomeReact';

//import HBarDEMO from '../samples/HBarHomeReact';
//import { textCode as HBarDEMOReact } from '../samples/HBarHomeReact';
//import { textCode as HBarDEMOJQ } from '../samples/HBarHomeJQ';

import BubbleDEMO from '../samples/BubbleHomeReact';
import { textCode as BubbleDEMOReact } from '../samples/BubbleHomeReact';
import { textCode as BubbleDEMOJQ } from '../samples/BubbleHomeJQ';
import { src as Bubblesrc } from '../samples/BubbleHomeReact';

import LinealRegressionDEMO from '../samples/LinealRegressionReact';
import { textCode as LinealRegressionDEMOReact } from '../samples/LinealRegressionReact';
import { textCode as LinealRegressionDEMOJQ } from '../samples/BubbleHomeJQ';
import { src as LinealRegressionsrc } from '../samples/LinealRegressionReact';


import DescriptiveGPUDEMO from '../samples/DescriptiveGPUReact';
import { textCode as DescriptiveGPUDEMOReact } from '../samples/DescriptiveGPUReact';
import { textCodeJQ as DescriptiveGPUDEMOJQ } from '../samples/DescriptiveGPUReact';
import { src as DescriptiveGPUsrc } from '../samples/DescriptiveGPUReact';

import AnomalyDEMO from '../samples/AnomalyReact';
import { textCode as AnomalyDEMOReact } from '../samples/AnomalyReact';
import { textCodeJQ as AnomalyDEMOJQ } from '../samples/AnomalyReact';
import { src as Anomalysrc } from '../samples/AnomalyReact';

import RegressionGraDescGPUDEMO from '../samples/Regressiongraddescgpu';
import { textCode as RegressionGraDescGPUDEMOReact } from '../samples/Regressiongraddescgpu';
import { textCodeJQ as RegressionGraDescGPUDEMOJQ } from '../samples/Regressiongraddescgpu';
import { src as RegressionGraDescGPUsrc } from '../samples/Regressiongraddescgpu';

import SidebarDOC from '../samples/SidebarHomeDOC'
import WelcomeDOC from '../samples/ContentDOC'

//icons
import LineChartIcon from 'grommet/components/icons/base/LineChart';
import OptimizeIcon from 'grommet/components/icons/base/Optimize';
import CalculatorIcon from 'grommet/components/icons/base/Calculator';

//For HOME

import Piedata from "../samples/data/selectdatasource.js";
import Pieoptions from "../samples/options/pie.js";
import Pierun from "../samples/run/pie.js";

import Baroptions from "../samples/options/bar.js";
import Barrun from "../samples/run/bar.js";

//import Lineoptions from "../samples/options/line.js";
//import Linerun from "../samples/run/line.js";

import Scatteroptions from "../samples/options/scatter.js";
import Scatterrun from "../samples/run/scatter.js";

import LlsOptions from "../samples/options/lrmse.js";
import LlsRun from "../samples/run/lrmse.js";

import LgdOptions from "../samples/options/lrgd.js";
import LgdRun from "../samples/run/lrgd.js";
import MLgdRun from "../samples/run/mlrgd.js";

import MultiScatteroptions from "../samples/options/multiscatter.js";
import MultiScatterrun from "../samples/run/multiscatter.js";

import Boxplotoptions from "../samples/options/boxplotoptions.js";
import Boxplotrun from "../samples/run/boxplotrun.js";

import Histogramoptions from "../samples/options/histogramoptions";
import Histogramrun from "../samples/run/histogramrun";

import DescrStatoptions from "../samples/options/descrstat.js";
import DescStatrun from "../samples/run/descrstat.js";

import Anomalyoptions from "../samples/options/anomaly.js";
import Anomalyrun from "../samples/run/anomaly.js";

import Dataselect from "../samples/data/dataselect.js";
import Dataoptions from "../samples/data/dataoptions.js";
import Datarun from "../samples/data/datarun.js";
import DataDist from "../samples/data/datadist.js";
import DataOutliers from "../samples/data/dataoutliers.js";
import DataMultiCorr from "../samples/data/datamulticorr.js";

//import Label from 'grommet/components/Label';
import BarChartIcon from 'grommet/components/icons/base/BarChart';
//import BrandGrommetOutlineIcon from 'grommet/components/icons/base/BrandGrommetOutline';
import PieChartIcon from 'grommet/components/icons/base/PieChart';
import AccessBrailleIcon from 'grommet/components/icons/base/AccessBraille';
//import NodesIcon from 'grommet/components/icons/base/Nodes';
//import InheritIcon from 'grommet/components/icons/base/Inherit';
//import DownIcon from 'grommet/components/icons/base/Down';
import CloudUploadIcon from 'grommet/components/icons/base/CloudUpload';
import TargetIcon from 'grommet/components/icons/base/Target';
import CapacityIcon from 'grommet/components/icons/base/Capacity';
import MultipleIcon from 'grommet/components/icons/base/Multiple';





const anomalyDocs = {description: "Anomaly Detection. It uses Gaussian Algorithm to calculate probability ditribution, assuming it has that shape. Values beyond Epsilon would be considered abnormal.",
label: "prophesieranomaly",
properties: [{
    defaultValue: "",
    description: "Data to train. All data should be considered a non-anomaly data point",
    label: "traindata",
    value: "Array"
}, {
    defaultValue: "",
    description: "Data to predict. Production data with anomaly and non-anomaly data points",
    label: "predictdata",
    value: "Array"
}, {
    defaultValue: "",
    description: "Period or seasonality of the data per data point. This version only accepts 1 seasonality per serie",
    label: "steps",
    value: "Number"
}, {
    defaultValue: "",
    description: "Threshold or sensibility of the algorithm to tag a point as anomaly or no-anomaly. Change this value if many good values are tagged as anomalies",
    label: "epsilon",
    value: "Number"
}]

}

const linearGradDocs = {description: "Simple Linear Regression using Gradient Descent Algorithm. Learning calculations are performed in the GPU.",
label: "prophesieranomaly",
properties: [{
    defaultValue: "",
    description: "Array containing xs and ys",
    label: "data",
    value: "Array<Array>"
}, {
    defaultValue: "",
    description: "Learning Rate for the gradient descent algorithm",
    label: "learningrate",
    value: "Array"
}, {
    defaultValue: "",
    description: "Number of iterations",
    label: "iterations",
    value: "Number"
}]

}

const descriptiveStats = {description: "Descriptive statistics for a multi dimensional set of Arrays. It uses GPU to do calculations, allowing large number of inputs",
label: "prophesieranomaly",
properties: [{
    defaultValue: "",
    description: "Array containing datasets x1, x2, .. xn",
    label: "data",
    value: "Array<Array>"
}]

}

const Data = [
    {
        title: "Home",
        tag: "Home",
        path: "components/sidebar/Sidebar",
        icon: "",
        description: "Installation",
        contentDOC: (<WelcomeDOC />),
        contentDEMO: "",
        contentDEMOReact: "",
        contentDEMOJQ: "",
        contentDEMOVue: "",
        src: ""
    }, {
        title: "Models",
        tag: "Get Started",
        icon: "",
        description: "",
        contentDOC: "",
        contentDEMO: "",
        contentDEMOReact: "",
        contentDEMOJQ: "",
        contentDEMOVue: "",
        src: ""
    }, {
        title: "Anomaly Analysis",
        tag: "",
        icon: OptimizeIcon,
        description: "Anomaly Analysis",
        contentDOC: (<SidebarDOC doc={anomalyDocs} />),
        contentDEMO: (<AnomalyDEMO />),
        contentDEMOReact: AnomalyDEMOReact,
        contentDEMOJQ: AnomalyDEMOJQ,
        contentDEMOVue: 'Future release...',
        src: Anomalysrc
    }, {
        title: "Linear Gradient Descent",
        tag: "<prophesier-regressiongradesc-gpu /> <RegressionGraDescGPU />",
        icon: LineChartIcon,
        description: "Linear Regression using Gradiente Descent Algorithm. Calculations for training are done in the GPU",
        contentDOC: (<SidebarDOC doc={linearGradDocs} />),
        contentDEMO: (<RegressionGraDescGPUDEMO />),
        contentDEMOReact: RegressionGraDescGPUDEMOReact,
        contentDEMOJQ: RegressionGraDescGPUDEMOJQ,
        contentDEMOVue: 'Future release...',
        src: RegressionGraDescGPUsrc
    }/* , {
        title: "Multiscatter charts",
        tag: "<prophesier-regressiongradesc-gpu /> <RegressionGraDescGPU />",
        icon: "dna-radio-unselected",
        description: "Multiscatter",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxbubble} />),
        contentDEMO: (<DescriptiveGPUDEMO />),
        contentDEMOReact: DescriptiveGPUDEMOReact,
        contentDEMOJQ: DescriptiveGPUDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: DescriptiveGPUsrc
    } */, {
        title: "Descriptive Metrics",
        tag: "<prophesier-descriptive-gpu /> <DescriptiveGPU />",
        icon: CalculatorIcon,
        description: "Descriptive statistics for a multidimensional array input. Calculates min, max, range, mean, variance. GPU used for processing",
        contentDOC: <SidebarDOC doc={descriptiveStats} />,
        contentDEMO: (<DescriptiveGPUDEMO />),
        contentDEMOReact: DescriptiveGPUDEMOReact,
        contentDEMOJQ: DescriptiveGPUDEMOJQ,
        contentDEMOVue: 'Future release...',
        src: DescriptiveGPUsrc
    }/*, {
        title: "Donut",
        tag: "<prophesier-donut-chart /> <DonutChart />",
        icon: "dna-radio-unselected",
        description: "A single donut chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxdonut} />),
        contentDEMO: (<PieChartDEMO />),
        contentDEMOReact: PieChartDEMOReact,
        contentDEMOJQ: PieChartDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: PieChartsrc
    } , {
        title: "Double Donut",
        tag: "",
        icon: "dna-radio-unselected",
        description: "A double donut chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxdonut} />),
        contentDEMO: (<DoublePieChartDEMO />),
        contentDEMOReact: DoublePieChartDEMOReact,
        contentDEMOJQ: DoublePieChartDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: DoublePieChartsrc
    }, {
        title: "Line",
        tag: "",
        icon: "dna-radio-unselected",
        description: "A line chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxline} />),
        contentDEMO: (<TimelineTDEMO />),
        contentDEMOReact: TimelineTDEMOReact,
        contentDEMOJQ: TimelineTDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: TimelineTsrc
    } , {
        title: "Bar",
        tag: "<prophesier-bar-chart /> <BarChart />",
        icon: "dna-radio-unselected",
        description: "A bar chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxbar} />),
        contentDEMO: (<BarDEMO />),
        contentDEMOReact: BarDEMOReact,
        contentDEMOJQ: BarDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: Barsrc
    } , {
        title: "Bubble",
        tag: "",
        icon: "dna-radio-unselected",
        description: "A bubble chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxbubble} />),
        contentDEMO: (<BubbleDEMO />),
        contentDEMOReact: BubbleDEMOReact,
        contentDEMOJQ: BubbleDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: Bubblesrc
    } , {
        title: "Fit Model",
        icon: "",
        description: "",
        contentDOC: "",
        contentDEMO: "",
        contentDEMOReact: "",
        contentDEMOJQ: "",
        contentDEMOVue: "",
        src: ""
    }, {
        title: "Multiple Scatter",
        tag: "",
        icon: "dna-radio-unselected",
        description: "A multiple scatter chart",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxbubble} />),
        contentDEMO: (<MulScatterDEMO />),
        contentDEMOReact: MulScatterDEMOReact,
        contentDEMOJQ: MulScatterDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: MulScattersrc
    }, {
        title: "LinealrRegresion Grad Desc",
        tag: "<lineal-regression />",
        icon: "dna-radio-unselected",
        description: "Linear Regression",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxlinealregression} />),
        contentDEMO: "NA", //(<LinealRegressionDEMO />),
        contentDEMOReact: LinealRegressionDEMOReact,
        contentDEMOJQ: LinealRegressionDEMOJQ,
        contentDEMOVue: 'working on this...',
        src: LinealRegressionsrc
    }, {
        title: "HBar",
        tag: "",
        icon: "dna-radio-unselected",
        description: "HBar",
        contentDOC: (<SidebarDOC doc={cumulObject.dnxhbar} />),
        contentDEMO: (<HBarDEMO />),
        contentDEMOReact: HBarDEMOReact,
        contentDEMOJQ: HBarDEMOJQ,
        contentDEMOVue: 'working on this...'
    }*/
];

export const charts = [
    {
      name: "Donut", 
      icon: PieChartIcon, 
      dataOptions: Dataselect, 
      optionsContent: Pieoptions,
      runOptions: Pierun
    }, 
    /* {
      name: "Double Donut", 
      icon: BrandGrommetOutlineIcon, 
      dataOptions: Piedata, 
      optionsContent: Pieoptions,
      runOptions: Pierun
    }, 
    {
      name: "Line", 
      icon: LineChartIcon, 
      dataOptions: Piedata, 
      optionsContent: Lineoptions,
      runOptions: Linerun
    },  */
    {
      name: "Bar", 
      icon: BarChartIcon, 
      dataOptions: Dataselect, 
      optionsContent: Baroptions,
      runOptions: Barrun
    }, {
      name: "Timeline", 
      icon: AccessBrailleIcon, 
      dataOptions: Dataselect, 
      optionsContent: Scatteroptions,
      runOptions: Scatterrun
    }
  ]

  export const statisticsDataSource = [
      {
          name: "Data Source",
          descriptionElement: "Enter or upload(csv file or via API) data to explore and run models. Use predifined datasets to just see how it works. Verify types and remove null/empty values for better results",
          linkElement: "",
          icon: CloudUploadIcon,
          dataOptions: Piedata,
          optionsContent: Dataoptions,
          runOptions: Datarun
      }
  ]
  export const statisticsExplore = [
    {
        name: "Descriptive Metrics",
        descriptionElement: "Descriptive Metrics GPU calculates minimum, maximum, mean, count and standard deviation. Only numeric values are accepted.",
        linkElement: "",
        icon: CalculatorIcon, 
        dataOptions: Dataselect, 
        optionsContent: DescrStatoptions,
        runOptions: DescStatrun
    }/* , {
        name: "Descriptive Metrics CPU",
        descriptionElement: "Descriptive Metrics CPU calculates minimum, maximum, mean, count and standard deviation. Only numeric values are accepted.",
        linkElement: "",
        icon: CalculatorIcon, 
        dataOptions: Dataselect, 
        optionsContent: DescrStatoptions,
        runOptions: DescStatrun
    } */, {
      name: "Multiple Scatter",
      descriptionElement: "Multiple scatter calculates scatter diagram for each pair combination of values selected. It also includes R2 and linear equation. Use this chart to quickly spot relationships between two or more variables",
      linkElement: "https://en.wikipedia.org/wiki/Scatter_plot",
      icon: AccessBrailleIcon, 
      dataOptions: Dataselect, 
      optionsContent: MultiScatteroptions,
      runOptions: MultiScatterrun
    }, {
        name: "Boxplots",
        descriptionElement: "Calculate Boxplots for each numeric value selected. It renders minimumn, maximum, median, 25 and 75 percentiles. This helps understanding the distribution of the data and potential outliers",
        linkElement: "https://en.wikipedia.org/wiki/Box_plot",
        icon: CapacityIcon, 
        dataOptions: Dataselect, 
        optionsContent: Boxplotoptions,
        runOptions: Boxplotrun
    }, {
        name: "Histograms",
        descriptionElement: "Calculate Histogram for each numeric value selected. Enter number of partitions to evaluate the statistic distribution of the dataset",
        linkElement: "https://en.wikipedia.org/wiki/Histogram",
        icon: BarChartIcon, 
        dataOptions: Dataselect, 
        optionsContent: Histogramoptions,
        runOptions: Histogramrun
      }
  ]

  export const statisticsFitModel = [
    /*{
      name: "Linear Gradient Descent",
      descriptionElement: "Simple Linear Regression (2 variables) using Gradient Descent and GPU. Select variables and chose learning rates and iterations. Evaluate results and do adjustments to improve output",
      linkElement: "https://en.wikipedia.org/wiki/Gradient_descent",
      icon: LineChartIcon, 
      dataOptions: Dataselect, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    } , {
      name: "Linear Gradient Descent CPU",
      descriptionElement: "Simple Linear Regression (2 variables) using Gradient Descent and CPU. Select variables and chose learning rates and iterations. Evaluate results and do adjustments to improve output",
      linkElement: "https://en.wikipedia.org/wiki/Gradient_descent",
      icon: LineChartIcon, 
      dataOptions: Dataselect, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    } */
    {
        name: "Data Preparation",
        descriptionElement: "Evaluate Assumptions and perform data cleansing",
        linkElement: "",
        icon: TargetIcon,
        dataSource: Piedata,
        dataValidate: Datarun,
        dataOutliers: DataOutliers,
        dataDist: DataDist,
        dataMultiCorr: DataMultiCorr,
        dataOptions: Dataselect, 
        dataExplore: Dataselect,
        optionsContent: DescrStatoptions,
        runOptions: DescStatrun
      }/*,{
      name: "Anomaly Analysis",
      descriptionElement: "Identify abnormal values. Evaluate seasonality in Time Series datasets by setting Steps. User can enter Predict/Test Data to evaluate the model after training",
      linkElement: "https://en.wikipedia.org/wiki/Anomaly_detection",
      icon: TargetIcon,
      dataSource: Piedata,
      dataValidate: Datarun,
      dataOutliers: DataOutliers,
      dataDist: DataDist,
      dataMultiCorr: DataMultiCorr,
      dataOptions: Dataselect, 
      dataExplore: Dataselect,
      optionsContent: Anomalyoptions,
      runOptions: Anomalyrun
    } , {
      name: "Logistic Gradient Descent",
      descriptionElement: "Simple Logistic Regression (2 variables) using Gradient Descent and CPU. Select variables and chose learning rates and iterations. Evaluate results and do adjustments to improve output",
      linkElement: "https://en.wikipedia.org/wiki/Gradient_descent",
      icon: OptimizeIcon, 
      dataOptions: Dataselect, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    } , {
      name: "Multi Linear Regression",
      descriptionElement: "Multilinear Regression (2 or more dependent variables) using Gradient Descent. Select variables and chose learning rates and iterations. Evaluate results and do adjustments to improve output",
      linkElement: "https://en.wikipedia.org/wiki/Gradient_descent",
      icon: MultipleIcon, 
      dataSource: Piedata,
      dataValidate: Datarun,
      dataOutliers: DataOutliers,
      dataDist: DataDist,
      dataMultiCorr: DataMultiCorr,
      dataOptions: Dataselect,
      dataExplore: Dataselect,
      optionsContent: LgdOptions,
      runOptions: MLgdRun
    }, {
        name: "Multi Logistic Regression",
        descriptionElement: "Multi logistic Regression (2 or more dependent variables and yes/no independent variable) using Gradient Descent. Select variables and chose learning rates and iterations. Evaluate results and do adjustments to improve output",
        linkElement: "https://en.wikipedia.org/wiki/Gradient_descent",
        icon: MultipleIcon, 
        dataSource: Piedata,
        dataValidate: Datarun,
        dataOutliers: DataOutliers,
        dataDist: DataDist,
        dataMultiCorr: DataMultiCorr,
        dataOptions: Dataselect,
        dataExplore: Dataselect, 
        optionsContent: LgdOptions,
        runOptions: MLgdRun
      }/*
    {
      name: "Lineal Neuron Analysis GPU", 
      icon: NodesIcon, 
      dataOptions: Piedata, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    }, {
      name: "Linear Least Squares CPU", 
      icon: LineChartIcon, 
      dataOptions: Piedata, 
      optionsContent: LlsOptions,
      runOptions: LlsRun
    }, {
      name: "Log Regression CPU", 
      icon: LineChartIcon, 
      dataOptions: Piedata, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    },
    {
      name: "Log Regression GPU", 
      icon: LineChartIcon, 
      dataOptions: Piedata, 
      optionsContent: LgdOptions,
      runOptions: LgdRun
    },  */
     
  ]

export default Data;



// WEBPACK FOOTER //
// ./src/data/Data.js